<template>
  <div class="org-modal">
    <div ref="orgUnitEditModal" class="modal fade" data-bs-backdrop="static" id="orgUnitEditModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" v-draggable-modal>
        <div class="modal-content bg-primary">
          <div class="modal-header">
            <div class="h5 modal-title text-light me-2"> {{ modalTitle }} </div>
            <DocsInfoLink color="light" target="createOrg"></DocsInfoLink>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body bg-light">
            <div v-if="elementType === 'orgUnit'" class="form-org-unit">
              <div v-if="selectedView !== 'vision'" class="row mb-3">
                <div class="col">
                  <label for="orgParent" class="form-label">{{ $t("views.org.edit.parentOrgUnit") }}<span class="text-danger">*</span></label>
                  <select v-model="form.orgUnit.parentId.content" class="form-select" id="orgParent">
                    <option value="" :disabled="!isAdmin">{{ $t("views.org.edit.noParentOrgUnit") }}</option>
                    <option v-for="orgUnit in orgUnitsList" :key="orgUnit.id" :value="orgUnit.id" :disabled="mode === 'update' && orgUnit.id === selectedOrgUnit.id ? true : false">
                      {{ orgUnit.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col">
                  <label for="orgUnitName" class="form-label">{{ $t("views.org.edit.name") }}<span class="text-danger">*</span></label>
                  <input v-model="form.orgUnit.name.content" id="orgUnitName" :class="form.orgUnit.name.error === '' ? 'form-control' : 'form-control is-invalid'" :disabled="selectedView === 'vision'">
                  <div class="invalid-feedback">{{ form.orgUnit.name.error }}</div>
                </div>
              </div>
              <div v-if="selectedView !== 'vision'" class="row mb-3">
                <div class="col">
                  <label for="orgUnitDescription" class="form-label">{{ $t("views.org.edit.description") }}</label>
                  <RTEditor ref="orgUnitDescription" v-model="form.orgUnit.description.content" contentType="html" id="orgUnitDescription"></RTEditor>
                  <div class="quill-invalid-feedback">{{ form.orgUnit.description.error }}</div>
                </div>
              </div>
              <div v-if="selectedView === 'vision'" class="row mb-3">
                <div class="col">
                  <label for="orgUnitPurpose" class="form-label">{{ $t("views.org.edit.purpose") }}</label>
                  <RTEditor ref="orgUnitPurpose" v-model="form.orgUnit.purpose.content" contentType="html" id="orgUnitPurpose"></RTEditor>
                  <div class="quill-invalid-feedback">{{ form.orgUnit.purpose.error }}</div>
                </div>
              </div>
              <div class="row mb-3">
                <div v-if="selectedView === 'vision'" class="row mb-3">
                <div class="col">
                  <label for="orgUnitVision" class="form-label">{{ $t("views.org.edit.vision") }}</label>
                  <RTEditor ref="orgUnitVision" v-model="form.orgUnit.vision.content" contentType="html" id="orgUnitVision"></RTEditor>
                  <div class="quill-invalid-feedback">{{ form.orgUnit.vision.error }}</div>
                </div>
              </div>
                <div v-if="selectedView === 'vision'" class="col">
                  <label for="orgUnitMission" class="form-label">{{ $t("views.org.edit.mission") }}</label>
                  <RTEditor ref="orgUnitMission" v-model="form.orgUnit.mission.content" contentType="html" id="orgUnitMission"></RTEditor>
                  <div class="quill-invalid-feedback">{{ form.orgUnit.mission.error }}</div>
                </div>
              </div>
              <div v-if="selectedView === 'vision'" class="row mb-3">
                <div class="col">
                  <label for="orgUnitCorporateValue" class="form-label">{{ $t("views.org.edit.corporateValue") }}</label>
                  <RTEditor ref="orgUnitCorporateValue" v-model="form.orgUnit.corporateValue.content" contentType="html" id="orgUnitCorporateValue"></RTEditor>
                  <div class="quill-invalid-feedback">{{ form.orgUnit.corporateValue.error }}</div>
                </div>
              </div>
              <div v-if="selectedView !== 'vision'" class="row mb-3">
                <div class="col">
                  <div class="form-check form-switch">
                    <input @change="toggleOrgValidCheck(!validCheck)" type="checkbox" role="switch" id="orgUnitValidCheck" class="form-check-input" :checked="validCheck">
                    <label for="orgUnitValidCheck" class="form-check-label">{{ $t("views.org.edit.validCheck") }}</label>
                  </div>
                </div>
              </div>
              <div v-if="validCheck && selectedView !== 'vision'" class="row mb-3">
                <div class="col-6">
                  <label for="orgUnitValidFrom" class="form-label">{{ $t("views.org.edit.validFrom") }}</label>
                  <input v-model="form.orgUnit.validFrom.content" type="date" id="orgUnitValidFrom" :class="form.orgUnit.validFrom.error === '' ? 'form-control' : 'form-control is-invalid'">
                  <div class="invalid-feedback">{{ form.orgUnit.validFrom.error }}</div>
                </div>
                <div class="col-6">
                  <label for="orgUnitValidTo" class="form-label">{{ $t("views.org.edit.validTo") }}</label>
                  <input v-model="form.orgUnit.validTo.content" type="date" id="orgUnitValidTo" :class="form.orgUnit.validTo.error === '' ? 'form-control' : 'form-control is-invalid'">
                  <div class="invalid-feedback">{{ form.orgUnit.validTo.error }}</div>
                </div>
              </div>
            </div>
            <div v-if="elementType === 'member'" class="form-org-unit">
              <div class="row mb-3">
                <div class="col">
                  <label for="existingEmployees" class="form-label">{{ $t("views.org.edit.selectEmployee") }}<span class="text-danger">*</span></label>
                  <select v-model="form.member.employeeId.content" class="form-select" id="existingEmployees" :disabled="mode === 'update'" :class="form.member.employeeId.error === '' ? ' form-control' : 'form-control is-invalid'">
                    <option v-for="person in employees" :key="person.id" :value="person.id">
                      {{ person.lastName }}, {{ person.firstName }}
                    </option>
                  </select>
                  <div class="invalid-feedback">{{ form.member.employeeId.error }}</div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col">
                  <label for="role" class="form-label">{{ $t("general.role") }}<span class="text-danger">*</span></label>
                    <select v-model="form.member.role.content" class="form-select" id="role" :class="form.member.role.error === '' ? ' form-control' : 'form-control is-invalid'">
                      <option value="+" class="bg-custom-blue">{{ $t("general.addRole") }} </option>
                      <option v-for="role in orgUnitRoles" :key="role.id" :value="role">
                        {{ role }}
                      </option>
                    </select>
                    <div class="invalid-feedback">{{ form.member.role.error }}</div>
                    <div v-if="addRole">
                      <input v-model="form.member.newRole.content" type="text" id="newRole" :class="form.member.newRole.error === '' ? ' form-control' : 'form-control is-invalid'">
                      <div class="invalid-feedback">{{ form.member.newRole.error }}</div>
                    </div>
                  <div class="form-check">
                    <input
                      class="form-check-input" type="checkbox" id="leadIndicator" v-model="form.member.leadIndicator.content">
                    <label class="form-check-label" for="leadIndicator">{{ $t("general.headof") }}</label>
                    <div v-if="form.member.leadIndicator.error" class="invalid-feedback d-block">
                      {{ form.member.leadIndicator.error }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer bg-light justify-content-between">
            <div>
              <button type="button" class="btn btn-sm btn-outline-danger" :class="selectedOrgUnit.hasNodes ? 'disabled' : ''" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#orgUnitDeleteModal">{{ $t("general.delete") }}</button></div>
            <div>
              <button @click="cancel()" type="button" class="btn btn-sm btn-outline-secondary me-2" data-bs-dismiss="modal">{{ $t("general.close") }}</button>
              <button @click="save()" type="button" class="btn btn-sm btn-primary">{{ $t("general.save") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import initializeForm from '../../composables/initializeForm'
import setFormContent from '../../composables/setFormContent'
import * as validation from '../../composables/validation'
import DocsInfoLink from '../../components/DocsInfoLink.vue'
import RTEditor from '../RTEditor.vue'
import { Modal } from 'bootstrap'
import { ref } from 'vue'
import { i18n } from '../../i18n'

export default {
  name: 'OrgUnitEditModal',
  mounted () {
    const myModalDialog = document.getElementById('orgUnitEditModal')

    myModalDialog.addEventListener('shown.bs.modal', event => {
      const mode = this.$parent.orgUnitModalMode
      if (mode === 'add') {
        initializeForm(this.form.orgUnit)
        initializeForm(this.form.member)
        this.form.orgUnit.parentId.content = this.$store.state.selectedOrgUnit.id
      }
      if (mode === 'update') {
        this.oldRoleContent = this.form.member.role.content
      }
    })
    myModalDialog.addEventListener('hidden.bs.modal', event => {
      const mode = this.$parent.orgUnitModalMode
      if (mode !== 'add' && mode !== 'delete') {
        setFormContent(this.form, this.$store.state.selectedOrgUnit, 'orgUnit', this.elementType, this.$parent.orgUnitModalElementId)
      }
    })
  },
  data () {
    return {
      oldRoleContent: '',
      form: {
        orgUnit: {
          parentId: {
            content: '',
            error: '',
            validate: []
          },
          name: {
            content: '',
            error: '',
            maxLength: 255,
            validate: ['empty', 'length']
          },
          description: {
            content: '',
            error: '',
            validate: [],
            rtEditor: true,
            ref: 'orgUnitDescription'
          },
          purpose: {
            content: '',
            error: '',
            validate: [],
            rtEditor: true,
            ref: 'orgUnitPurpose'
          },
          mission: {
            content: '',
            error: '',
            validate: [],
            rtEditor: true,
            ref: 'orgUnitMission'
          },
          vision: {
            content: '',
            error: '',
            validate: [],
            rtEditor: true,
            ref: 'orgUnitVision'
          },
          corporateValue: {
            content: '',
            error: '',
            validate: [],
            rtEditor: true,
            ref: 'orgUnitCorporateValue'
          },
          validFrom: {
            content: '',
            error: '',
            validate: ['validFrom']
          },
          validTo: {
            content: '',
            error: '',
            validate: ['validTo']
          }
        },
        member: {
          employeeId: {
            content: '',
            error: '',
            validate: ['empty']
          },
          role: {
            content: '',
            error: '',
            validate: ['empty']
          },
          newRole: {
            content: '',
            error: '',
            validate: ['empty']
          },
          leadIndicator: {
            content: false,
            error: '',
            validate: []
          }
        }
      },
      selectedElement: ''
    }
  },
  components: {
    DocsInfoLink,
    RTEditor
  },
  computed: {
    elementId () {
      return this.$parent.orgUnitModalElementId
    },
    elementType () {
      return this.$parent.orgUnitModalElementType
    },
    mode () {
      return this.$parent.orgUnitModalMode
    },
    orgUnitsList () {
      return this.$store.state.orgUnitsList
    },
    employees () {
      return this.$store.state.employees
    },
    selectedOrgUnit () {
      return this.$store.state.selectedOrgUnit
    },
    orgUnitRoles () {
      return this.$store.state.orgUnitRoles
    },
    selectedView () {
      return this.$store.state.selectedView
    },
    validCheck () {
      if (this.form.orgUnit.validFrom.content) {
        return true
      }
      return false
    },
    addRole () {
      if (this.form.member.role.content === '+') {
        return true
      } else {
        return false
      }
    },
    isAdmin () {
      return this.$store.state.user.role === 10387
    },
    modalTitle () {
      const titles = {
        orgUnit: {
          add: this.$t('views.org.structure.headingAddOrgUnit'),
          update: this.$t('views.org.structure.headingEditOrgUnit')
        },
        member: {
          add: this.$t('views.org.structure.headingAddMember'),
          update: this.$t('views.org.structure.headingEditMember')
        }
      }
      return titles[this.elementType]?.[this.mode] ?? ''
    }
  },
  methods: {
    cancel () {
      initializeForm(this.form.orgUnit)
      initializeForm(this.form.member)
    },
    async save () {
      this.$store.commit('SET_LOADING_STATUS', true)

      let valid = 0
      if (this.elementType === 'member') {
        if (this.form.member.role.content === '+') {
          this.form.member.role.content = this.form.member.newRole.content
        } else {
          this.form.member.newRole.validate = []
          this.form.member.newRole.content = ''
        }

        valid = validation.fieldValidation(this.form.member)
        // Check if employee is already assigned to this organizational unit
        if (this.$parent.orgUnitModalMode === 'update' && this.oldRoleContent === this.form.member.role.content) {
          // do nothing
        } else {
          const exists = this.$store.state.selectedOrgUnit.members.some(m => (m.employeeId === this.form.member.employeeId.content && m.role === this.form.member.role.content))
          if (exists) {
            valid++
            this.form.member.employeeId.error = i18n?.global.t('error.2037', this.$store.state.user.settings.language)
          }
        }
        // Check if newRole is already existing role
        const exists = this.$store.state.selectedOrgUnit.roles.includes(this.form.member.newRole.content)
        if (exists) {
          this.form.member.newRole.content = ''
        }
        // Check leadIndicator may be set only once
        const wantsLead = this.form.member.leadIndicator.content === true
        if (wantsLead && this.$store.state.selectedOrgUnit.members.some(m => m.leadIndicator === true)) {
          valid++
          this.form.member.leadIndicator.error = i18n?.global.t('error.2038', this.$store.state.user.settings.language)
        }
      }

      if (valid === 0) {
        Object.keys(this.form[this.elementType]).forEach(field => {
          if (this.form[this.elementType][field].rtEditor) {
            const ref = this.form[this.elementType][field].ref
            if (this.$refs[ref]) {
              this.form[this.elementType][field].content = this.$refs[ref].getContent()
              if (this.form[this.elementType][field].content === '<p><br></p>') this.form[this.elementType][field].content = ''
            }
          }
        })

        const elementData = Object.assign(
          ...Object.entries(this.form[this.elementType]).map(([key, value]) => ({ [key]: value.content }))
        )
        if (elementData.parentId === undefined) elementData.parentId = ''
        if (elementData.folder === '') elementData.folder = 'false'

        elementData.id = this.elementId
        let dispatchFunc = ''
        if (this.elementType !== 'orgunit') {
          elementData.elementType = (this.elementType + 's')
          elementData.orgUnitId = this.selectedOrgUnit.id
        }
        dispatchFunc = this.elementType === 'orgUnit' ? (this.mode + 'OrgUnit') : (this.mode + 'OrgUnitElement')
        await this.$store.dispatch(dispatchFunc, elementData).then(() => {
          this.closeModal()
          Object.keys(this.form[this.elementType]).forEach(field => {
            if (this.mode === 'add') {
              this.form[this.elementType][field].content = ''
            }
            this.form[this.elementType][field].error = ''
          })
        })
      }
      this.$store.commit('SET_LOADING_STATUS', false)

      // Reload Data & Treeview
      if (this.elementType === 'orgUnit') {
        await this.$store.dispatch('getOrgUnits', { validFrom: this.$parent.filterValidFrom, validTo: this.$parent.filterValidTo, view: 'org' })
      }
    },
    toggleOrgValidCheck (validCheck) {
      if (validCheck) {
        if (this.mode === 'update' && this.selectedOrgUnit.validFrom && this.selectedOrgUnit.validTo) {
          [this.form.orgUnit.validFrom.content, this.form.orgUnit.validTo.content] = [this.selectedOrgUnit.validFrom, this.selectedOrgUnit.validTo]
        } else {
          this.form.orgUnit.validFrom.content = '2000-01-01'
          this.form.orgUnit.validTo.content = '2099-12-31'
        }
      } else {
        this.form.orgUnit.validFrom.content = this.form.orgUnit.validTo.content = ''
      }
    },
    updateModalContent () {
      setFormContent(this.form, this.elementType, this.$store.state.selectedOrgUnit, 'orgUnit')
    }
  },
  watch: {
    elementId () {
      const mode = this.$parent.orgUnitModalMode
      if (mode === 'update') {
        setFormContent(this.form, this.$store.state.selectedOrgUnit, 'orgUnit', this.elementType, this.$parent.orgUnitModalElementId)
      }
    },
    mode (newMode) {
      if (newMode === 'update') {
        setFormContent(this.form, this.$store.state.selectedOrgUnit, 'orgUnit', this.elementType, this.$parent.orgUnitModalElementId)
      }
    }
  },
  setup () {
    const orgUnitEditModal = ref(null)
    const closeModal = () => Modal.getInstance(orgUnitEditModal.value)?.hide()
    return { orgUnitEditModal, closeModal }
  }
}
</script>
